import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/customs/simulation',
}).lazy(() => import('./simulation.lazy').then((d) => d.Route))
